export const FILTER_ALL_INDUSTRIES = "All industries";
export const FILTER_ALL_COMPANY_SIZES = "All sizes";
export const FILTER_ALL_OWNERSHIP = "All ownership types";

export const WORKSPACE_OWNERSHIP = [
  "Private Equity-owned",
  "Founder-owned",
  "Family-owned",
  "Venture-backed",
  "Publicly listed",
  "Employee-owned (ESOP)",
  "Other",
];

export const WORKSPACE_INDUSTRIES = [
  "Business and Professional Services",
  "Consumer Products & Retail",
  "E-Commerce & Direct-to-Consumer",
  "Education & Training",
  "Energy & Utilities",
  "Financial Services & Fintech",
  "Food & Beverage",
  "Government & Defense",
  "Healthcare & Life Sciences",
  "Industrial & Manufacturing",
  "Logistics & Supply Chain",
  "Media & Entertainment",
  "Professional Services",
  "Real Estate & Construction",
  "Software & Technology",
  "Telecommunications",
  "Transportation & Infrastructure",
];

export const WORKSPACE_COMPANY_SIZES = [
  "Less than 200 employees",
  "201 – 500 employees",
  "501 – 1,000 employees",
  "1,001 – 2,000 employees",
  "2,001 – 3,500 employees",
  "3,501 – 5,000 employees",
  "More than 5000 employees",
];

export const REVENUE_OPTIONS = [
  "Less than $25 million",
  "USD $26 - $50 million",
  "USD $51 – 100 million",
  "USD $101 – 250 million",
  "USD $251 - $500 million",
  "USD $501 - $1 Billion",
  "USD $1 Billion +",
];

export const EBITDA_OPTIONS = [
  "USD $10 million or less",
  "USD $11 - $20 million",
  "USD $21 – $30 million",
  "USD $31 – $50 million",
  "USD $51 - $100 million",
  "USD $101 - $250 million",
  "USD $251 million +",
];
